const cases = [
  {
    category: '飲食店',
    name: '東京・恵比寿 ビストロCHAO',
    result: '月間報酬+48万円',
    detail: 'テーブルQRを活用したデリバリーサービス誘導で、来店外の売上チャンネルを開拓。導入2ヶ月で月間アフィリエイト収益が48万円を突破。',
    metric: '+230%',
    metricLabel: 'オンライン注文増加率',
    img: 'https://public.readdy.ai/ai/img_res/93d093d63f4767e5ffea19f4299b68d7.jpg',
    avatar: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20restaurant%20owner%20smiling%20professional%20headshot%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%20friendly%20expression&width=80&height=80&seq=av001&orientation=squarish',
    person: '山田 恵子 オーナー',
  },
  {
    category: 'アパレル',
    name: '大阪・心斎橋 SELECT BLOOM',
    result: '新規顧客+320名/月',
    detail: '試着室前のQRコードでECサイトへ誘導。試着した商品を後でオンライン購入するフローを確立し、機会損失をゼロに。SNSフォロワーとの相乗効果も抜群。',
    metric: '¥0',
    metricLabel: '追加マーケ費用',
    img: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20fashion%20boutique%20store%20interior%20with%20clothes%20on%20racks%2C%20stylish%20apparel%20shop%20in%20Osaka%2C%20clean%20white%20aesthetic%2C%20luxury%20retail%20design&width=400&height=280&seq=case002&orientation=landscape',
    avatar: 'https://readdy.ai/api/search-image?query=Japanese%20young%20man%20fashion%20store%20manager%20professional%20portrait%2C%20modern%20styling%2C%20confident%20smile%2C%20clean%20background&width=80&height=80&seq=av002&orientation=squarish',
    person: '田中 翔 店長',
  },
  {
    category: '美容・サロン',
    name: '名古屋 hair salon MUSE',
    result: 'リピート率91%達成',
    detail: '施術後にQRスキャンで次回予約＋商品紹介を自動化。来店客が自然にアフィリエイターになる仕組みを構築。口コミ拡散と成果報酬を同時に実現。',
    metric: '3.2倍',
    metricLabel: '口コミ拡散効果',
    img: 'https://readdy.ai/api/search-image?query=luxurious%20modern%20hair%20salon%20interior%20with%20styling%20chairs%2C%20elegant%20beauty%20salon%20design%2C%20clean%20contemporary%20space%2C%20professional%20hairdressing%20studio&width=400&height=280&seq=case003&orientation=landscape',
    avatar: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20hair%20salon%20owner%20professional%20portrait%2C%20stylish%20fashion%2C%20natural%20makeup%2C%20warm%20smile%2C%20light%20background&width=80&height=80&seq=av003&orientation=squarish',
    person: '鈴木 美香 代表',
  },
];

export default function CaseStudies() {
  return (
    <section id="cases" className="py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-red-500 text-sm font-bold tracking-widest uppercase">Case Studies</span>
          <h2 className="text-4xl font-black text-gray-900 mt-3 mb-4">導入事例</h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
            業種を問わず、多くの店舗が STORADで売上と顧客接点を拡大しています。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
          {cases.map((c, i) => (
            <div key={i} className="bg-white rounded-xl overflow-hidden flex flex-col">
              <div className="relative h-48 overflow-hidden">
                <img src={c.img} alt={c.name} className="w-full h-full object-cover object-top" />
                <div className="absolute top-3 left-3 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                  {c.category}
                </div>
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <div className="bg-red-50 rounded-lg px-4 py-3 mb-4 text-center">
                  <div className="text-red-500 font-black text-2xl">{c.metric}</div>
                  <div className="text-gray-500 text-xs mt-0.5">{c.metricLabel}</div>
                </div>
                <h3 className="text-gray-800 font-bold text-base mb-1">{c.name}</h3>
                <div className="text-red-500 font-bold text-sm mb-3">{c.result}</div>
                <p className="text-gray-500 text-sm leading-relaxed flex-1">{c.detail}</p>
                <div className="flex items-center gap-3 mt-5 pt-4 border-t border-gray-100">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img src={c.avatar} alt={c.person} className="w-full h-full object-cover" />
                  </div>
                  <div className="text-gray-600 text-xs">{c.person}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-xl p-8 border border-gray-100">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            {[
              { value: '2,400+', label: '導入店舗数' },
              { value: '¥850M+', label: '累計報酬支払額' },
              { value: '15業種', label: '対応業種' },
              { value: '4.8/5.0', label: '満足度スコア' },
            ].map((stat, i) => (
              <div key={i}>
                <div className="text-3xl font-black text-gray-900">{stat.value}</div>
                <div className="text-gray-400 text-xs mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
